type AnyObject = Record<string, any>;

interface GetValueObjectProps {
  name: string;
  data: any;
}

export const getValueObject = ({ name, data }: GetValueObjectProps) => {
  let value = "";
  const nameSplit = name.split(".");
  if (nameSplit.length > 2) {
    value = data[nameSplit[0]][nameSplit[1]][nameSplit[2]];
  } else if (nameSplit.length > 1) {
    value = data[nameSplit[0]][nameSplit[1]];
  } else {
    value = data[name];
  }
  return value;
};

export function cleanObject(obj: any) {
  const normalize = obj;
  const propNames = Object.getOwnPropertyNames(normalize);

  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    if (
      normalize[propName] === null ||
      normalize[propName] === undefined ||
      normalize[propName] === ""
    ) {
      delete normalize[propName];
    }
  }

  return normalize;
}

export const isHaveAccess = (allMenu: string[], menu: string) => allMenu.includes(menu);

export const abbreviator = (n: number, d: number) => {
  let x = ("" + n).length;
  const p = Math.pow;
  d = p(10, d);
  x -= x % 3;
  return Math.round((n * d) / p(10, x)) / d + " " + " KMGTPE"[x / 3];
};

export const keyList = (pathname: string) => {
  if (pathname === "/dashboard") return "home";
  if (pathname === "/performance") return "performance";
  return "home";
};

export const isEmpty = (obj: AnyObject) => {
  for(const prop in obj) {
    if(Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
};

export const isEmptyObject = (value: any) => {
  return Object.keys(value).length === 0 && value.constructor === Object;
};